import { useState, useEffect } from 'react';


const useDebugValues = (key:string):[boolean, (value:boolean)=>void,()=>void] => {

  const getDebugValues = () => {
    const jsonValue = sessionStorage.getItem('debugValues');
    return jsonValue != null ? JSON.parse(jsonValue) : {};
  };

  const [value, setValue] = useState(() => {
    const debugValues = getDebugValues();
    return !!debugValues[key];
  });


  useEffect(() => {
    const debugValues = getDebugValues();
    if (value) {
      debugValues[key] = true;
    } else {
      delete debugValues[key];
    }
    sessionStorage.setItem('debugValues', JSON.stringify(debugValues));
  }, [key, value]);
  const reset = ()=>{
    sessionStorage.removeItem('debugValues');
  }
  const toggleDebugValue = () => {
    setValue((prevValue) => !prevValue);
  };

  return [value, toggleDebugValue, reset];
};

export default useDebugValues;
